import { assertNever } from "../../lib/assertNever";
import { nothing, just, type Maybe } from "../../lib/maybe";

export type LinkTarget =
  | { kind: "entity"; entryFile: string }
  | { kind: "moment"; entryFile: string; momentId: string };
export type Model = { open: boolean; busy: boolean; error: Maybe<string> };
export const initialModel: Model = { open: false, busy: false, error: nothing };
export type Msg =
  | { type: "OpenChanged"; open: boolean }
  | { type: "Select"; target: LinkTarget; scenePath: string }
  | { type: "Saved" }
  | { type: "Failed"; error: string };
export type Cmd = { kind: "link"; target: LinkTarget; scenePath: string };
export function update(
  model: Model,
  msg: Msg,
): readonly [Model, readonly Cmd[]] {
  switch (msg.type) {
    case "OpenChanged":
      return [{ ...model, open: msg.open && model.busy === false }, []];
    case "Select":
      if (model.busy || msg.scenePath.length === 0) return [model, []];
      return [
        { open: false, busy: true, error: nothing },
        [{ kind: "link", target: msg.target, scenePath: msg.scenePath }],
      ];
    case "Saved":
      return [initialModel, []];
    case "Failed":
      return [{ open: false, busy: false, error: just(msg.error) }, []];
    default:
      return assertNever(msg);
  }
}
